import { Flex, Text, useToast } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaCopy, FaEye, FaPen, FaPlus, FaTrash } from 'react-icons/fa'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Button } from '../../../../components/Button'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import { ModalBase } from '../../../../components/ModalBase'
import { ModalDelete } from '../../../../components/ModalDelete'
import { NavLine } from '../../../../components/NavLine'
import { WhiteBox } from '../../../../components/WhiteBox'
import { useAuth } from '../../../../contexts/AuthContext'
import { iNomeId } from '../../../../interfaces'
import { appApi } from '../../../../services/appApi'
import { DestinoPosAprovacaoFeedback, FluxoEtapa, SubstringRoute } from '../../../../Utils/Helper'
import { Body } from '../../../Layouts/Body'
import { OutlineButton } from '../Components/OutlineButton'

export const FormulariosFeedback: React.FC = () => {
  const nav = useNavigate()
  const toast = useToast()
  const { pathname } = useLocation()
  const { feedbackId } = useParams<{ feedbackId: string }>()
  const { Permissoes } = useAuth()

  const FluxoGestao = pathname.includes('Empresa')

  const [Model, setModel] = useState<iNomeId[]>([])
  const [Id, setId] = useState<string>()
  const [ModalDeleteIsOpen, setModalDeleteIsOpen] = useState(false)
  const [FormularioSelecionado, setFormularioSelecionado] = useState<string>()
  const [IsSelecionando, setIsSelecionando] = useState(false)

  function ObterFormularios(): void {
    appApi.get('FormularioFeedback')
      .then(res => {
        if (res.status === 200) {
          setModel(res.data)
        }
      })
      .catch(err => console.log(err))
  }

  function Deletar(): void {
    appApi.delete(`FormularioFeedback/${Id ?? ''}`)
      .then(() => {
        toast({
          title: 'Formulário excluído com sucesso!',
          status: 'success',
          isClosable: false,
          position: 'top-right',
          duration: 4000
        })
        setModel([...Model.filter(e => e.id !== Id)])
      })
      .catch(err => console.log(err))
  }

  function Criar(): void {
    appApi.post('FormularioFeedback')
      .then(res => {
        if (FluxoGestao) {
          nav(pathname.replace('Formularios', `EditarFormulario/${res.data}`))
        } else {
          VincularEEditar(res.data)
        }
      })
      .catch(err => console.log(err))
  }

  function Duplicar(id: string): void {
    appApi.post(`FormularioFeedback/${id}/Duplicar`)
      .then(res => {
        if (!FluxoGestao) {
          VincularEEditar(res.data as string)
        } else {
          nav(pathname.replace('Formularios', `EditarFormulario/${res.data}`))
        }
      })
      .catch(err => console.log(err))
  }

  function VincularEEditar(formularioId: string): void {
    appApi.patch(`Feedback/${feedbackId ?? ''}/Formulario/${formularioId}`)
      .then(() => nav(`${pathname.replace('Formularios', 'EditarFormulario')}/${formularioId}`))
      .catch(err => console.log(err))
  }

  function Selecionar(formularioId: string): void {
    if (FluxoEtapa(pathname)) {
      Personalizar(formularioId)
    } else {
      setFormularioSelecionado(formularioId)
    }
  }

  function Aprovar(): void {
    if (FormularioSelecionado === undefined || IsSelecionando) return
    setIsSelecionando(true)
    appApi.patch(`Feedback/${feedbackId ?? ''}/Formulario/${FormularioSelecionado}?aprovar=true`)
      .then(res => {
        toast({
          title: 'Convite do feedback programado com sucesso!',
          status: 'success',
          isClosable: false,
          position: 'top-right',
          duration: 4000
        })
        const destino = DestinoPosAprovacaoFeedback(pathname, res.data?.reuniaoId, res.data?.participanteId)
        if (destino !== undefined) {
          nav(destino, { replace: true })
        } else {
          nav(-1)
        }
      })
      .catch(err => {
        console.log(err)
        setIsSelecionando(false)
      })
  }

  function Personalizar(formularioId: string): void {
    if (IsSelecionando) return
    setIsSelecionando(true)
    appApi.patch(`Feedback/${feedbackId ?? ''}/Formulario/${formularioId}`)
      .then(() => nav(`${pathname.replace('Formularios', 'Configuracao')}`))
      .catch(err => {
        console.log(err)
        setIsSelecionando(false)
      })
  }

  function OnOpenModalDelete(id: string): void {
    setId(id)
    setModalDeleteIsOpen(true)
  }

  function OnCloseModalDelete(): void {
    setId(undefined)
    setModalDeleteIsOpen(false)
  }

  useEffect(() => {
    ObterFormularios()
  }, [])

  return (
    <Body>
      <ModalDelete
        isOpen={ModalDeleteIsOpen}
        message='Deseja realmente excluir este formulário?'
        onConfirm={Deletar}
        onRequestClose={OnCloseModalDelete}
      />
      <ModalBase
        Titulo='Confirmar formulário'
        isOpen={FormularioSelecionado !== undefined}
        onClose={() => { if (!IsSelecionando) setFormularioSelecionado(undefined) }}
        Width='32rem'
      >
        <Flex flexDir={'column'} gap={'1rem'} p={'1rem'}>
          <Text fontSize={'.875rem'}>O convite será enviado agora com as configurações padrão.</Text>
          <Text fontSize={'.875rem'}>Para alterar os respondentes, os textos ou a data de envio, selecione Personalizar.</Text>
          <Flex justifyContent={'end'} gap={'.5rem'}>
            <ButtonCmp
              VarColor='Gray3'
              isDisabled={IsSelecionando}
              onClick={() => Personalizar(FormularioSelecionado ?? '')}
            >Personalizar</ButtonCmp>
            <ButtonCmp
              VarColor='Green2'
              isLoading={IsSelecionando}
              isDisabled={IsSelecionando}
              onClick={Aprovar}
            >Aprovar</ButtonCmp>
          </Flex>
        </Flex>
      </ModalBase>
      {pathname.includes('ReuniaoOne') &&
        <NavLine
          options={
            [{ nome: 'Reuniao 1:1', path: `${SubstringRoute(pathname, 'Feedback')}Dashboard/Individual` },
              { nome: 'Feedback' },
              { nome: 'Formularios' }
            ]}
        />
      }
      {FluxoGestao &&
        <Flex mb={'1rem'}>
          <Button onClick={() => nav(-1)} size={'lg'} VarColor='Gray3'>Voltar</Button>
        </Flex>
      }
      <WhiteBox>
        {!FluxoGestao &&
          <h2>Selecione ou crie um formulário novo</h2>
        }
        <Button
          my={'2rem'}
          w={'16rem'}
          VarColor={'v2'}
          leftIcon={<FaPlus />}
          isDisabled={!Permissoes.funcionalidades?.some(e => e.tipo === 5 && e.liberado) && !Permissoes.administrarFeedback
          }
          onClick={Criar}
        >Criar novo Formulário</Button>
        <Text fontWeight={'700'} fontSize={'22px'}>Formulários de feedback salvos:</Text>
        {Model.map(e => {
          return (
            <Flex key={e.id} gap={'.5rem'} my={'4px'} p={'1rem'} bgColor={'var(--Gray6)'}>
              <Text flex={'1'}>{e.nome}</Text>
              {!FluxoGestao &&
                <Button
                  h={'2rem'}
                  VarColor='v2'
                  fontSize={'0.875rem'}
                  onClick={() => Selecionar(e.id)}
                >Selecionar</Button>
              }

              {FluxoGestao &&
                <Button
                  h={'2rem'}
                  VarColor='v2'
                  fontSize={'0.875rem'}
                  leftIcon={<FaPen />}
                  onClick={() => nav(pathname.replace('Formularios', `EditarFormulario/${e.id}`))}
                >Editar</Button>
              }

              <OutlineButton
                onClick={() => Duplicar(e.id)}
                varColor='AzulClaro2'
                leftIcon={<FaCopy />}
                isDisabled={!Permissoes.funcionalidades?.some(e => e.tipo === 5 && e.liberado) && !Permissoes.administrarFeedback}
              >Duplicar</OutlineButton>

              <OutlineButton
                varColor='AzulClaro2'
                leftIcon={<FaEye />}
                onClick={() => nav(`/Feedback/Preenchimento/${e.id}/Previsualizar`)}
              >Pré-visualizar</OutlineButton>

              <OutlineButton
                onClick={() => OnOpenModalDelete(e.id)}
                varColor='Red'
                w={'1.75rem'}
                isDisabled={!Permissoes.funcionalidades?.some(e => e.tipo === 5 && e.liberado) && !Permissoes.administrarFeedback}
                leftIcon={<FaTrash />}
                pl={'1.2rem'}>
              </OutlineButton>
            </Flex>
          )
        })}
      </WhiteBox>
    </Body>
  )
}
